import axios from './config';

const post = (params, successCb, errorCb) => {
  axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/export/base`,
    params,
  ).then(
    res => successCb(res.data),
  ).catch(
    errorCb,
  );
};

const getDownloadUrl = (filename) => {
  return `${process.env.REACT_APP_API_BASE_URL}/export/download/${filename}`;
}

const listArticleNewsletters = (successCb, errorCb) => {
  axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/export/article-newsletters`,
  ).then(
    res => successCb(res.data),
  ).catch(
    errorCb,
  );
};

const postArticleNewsletter = (identifier, successCb, errorCb) => {
  axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/export/article-newsletter/${identifier}`,
  ).then(
    res => successCb(res.data),
  ).catch(
    errorCb,
  );
};

const endpoints = {
  post,
  getDownloadUrl,
  listArticleNewsletters,
  postArticleNewsletter,
};

export default endpoints;
